var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.98 2.09C22.329 0.932 21.6225 0.719 20.184 0.638C18.747 0.5405 15.1335 0.5 12.003 0.5C8.8665 0.5 5.2515 0.5405 3.816 0.6365C2.3805 0.719 1.6725 0.9305 1.0155 2.09C0.345 3.2465 0 5.2385 0 8.7455V8.7575C0 12.2495 0.345 14.2565 1.0155 15.401C1.6725 16.559 2.379 16.769 3.8145 16.8665C5.2515 16.9505 8.8665 17 12.003 17C15.1335 17 18.747 16.9505 20.1855 16.868C21.624 16.7705 22.3305 16.5605 22.9815 15.4025C23.658 14.258 24 12.251 24 8.759V8.747C24 5.2385 23.658 3.2465 22.98 2.09ZM9 13.25V4.25L16.5 8.75L9 13.25Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYou);
export default __webpack_public_path__ + "static/media/you.ab6d766703efaefd687903273082eb9a.svg";
export { ForwardRef as ReactComponent };